import { createFileRoute } from "@tanstack/react-router";
import { SignUpForm } from "~/components/views/auth/sign-up-form";

export const Route = createFileRoute("/auth/sign-up")({
	component: Page,
	loader() {
		return {
			languages: [
				{
					isO2: "aa",
					family: "Afro-Asiatic",
					isO3: "aar",
					localName: "Afaraf",
					name: "Afar",
					source: "https://en.wikipedia.org/wiki/Afar_language",
				},
				{
					isO2: "ab",
					family: "Northwest Caucasian",
					isO3: "abk",
					localName: "аҧсуа бызшәа, аҧсшәа",
					name: "Abkhaz",
					source: "https://en.wikipedia.org/wiki/Abkhaz_language",
				},
				{
					isO2: "ae",
					family: "Indo-European",
					isO3: "ave",
					localName: "avesta",
					name: "Avestan",
					source: "https://en.wikipedia.org/wiki/Avestan_language",
				},
				{
					isO2: "af",
					family: "Indo-European",
					isO3: "afr",
					localName: "Afrikaans",
					name: "Afrikaans",
					source: "https://en.wikipedia.org/wiki/Afrikaans_language",
				},
				{
					isO2: "ak",
					family: "Niger–Congo",
					isO3: "aka",
					localName: "Akan",
					name: "Akan",
					source: "https://en.wikipedia.org/wiki/Akan_language",
				},
				{
					isO2: "am",
					family: "Afro-Asiatic",
					isO3: "amh",
					localName: "አማርኛ",
					name: "Amharic",
					source: "https://en.wikipedia.org/wiki/Amharic_language",
				},
				{
					isO2: "an",
					family: "Indo-European",
					isO3: "arg",
					localName: "aragonés",
					name: "Aragonese",
					source: "https://en.wikipedia.org/wiki/Aragonese_language",
				},
				{
					isO2: "ar",
					family: "Afro-Asiatic",
					isO3: "ara",
					localName: "العربية",
					name: "Arabic",
					source: "https://en.wikipedia.org/wiki/Arabic_language",
				},
				{
					isO2: "as",
					family: "Indo-European",
					isO3: "asm",
					localName: "অসমীয়া",
					name: "Assamese",
					source: "https://en.wikipedia.org/wiki/Assamese_language",
				},
				{
					isO2: "av",
					family: "Northeast Caucasian",
					isO3: "ava",
					localName: "авар мацӀ, магӀарул мацӀ",
					name: "Avaric",
					source: "https://en.wikipedia.org/wiki/Avar_language",
				},
				{
					isO2: "ay",
					family: "Aymaran",
					isO3: "aym",
					localName: "aymar aru",
					name: "Aymara",
					source: "https://en.wikipedia.org/wiki/Aymara_language",
				},
				{
					isO2: "az",
					family: "Turkic",
					isO3: "aze",
					localName: "azərbaycan dili",
					name: "Azerbaijani",
					source: "https://en.wikipedia.org/wiki/Azerbaijani_language",
				},
				{
					isO2: "ba",
					family: "Turkic",
					isO3: "bak",
					localName: "башҡорт теле",
					name: "Bashkir",
					source: "https://en.wikipedia.org/wiki/Bashkir_language",
				},
				{
					isO2: "be",
					family: "Indo-European",
					isO3: "bel",
					localName: "беларуская мова",
					name: "Belarusian",
					source: "https://en.wikipedia.org/wiki/Belarusian_language",
				},
				{
					isO2: "bg",
					family: "Indo-European",
					isO3: "bul",
					localName: "български език",
					name: "Bulgarian",
					source: "https://en.wikipedia.org/wiki/Bulgarian_language",
				},
				{
					isO2: "bh",
					family: "Indo-European",
					isO3: "bih",
					localName: "भोजपुरी",
					name: "Bihari",
					source: "https://en.wikipedia.org/wiki/Bihari_languages",
				},
				{
					isO2: "bi",
					family: "Creole",
					isO3: "bis",
					localName: "Bislama",
					name: "Bislama",
					source: "https://en.wikipedia.org/wiki/Bislama_language",
				},
				{
					isO2: "bm",
					family: "Niger–Congo",
					isO3: "bam",
					localName: "bamanankan",
					name: "Bambara",
					source: "https://en.wikipedia.org/wiki/Bambara_language",
				},
				{
					isO2: "bn",
					family: "Indo-European",
					isO3: "ben",
					localName: "বাংলা",
					name: "Bengali, Bangla",
					source: "https://en.wikipedia.org/wiki/Bengali_language",
				},
				{
					isO2: "bo",
					family: "Sino-Tibetan",
					isO3: "bod",
					localName: "བོད་ཡིག",
					name: "Tibetan Standard, Tibetan, Central",
					source: "https://en.wikipedia.org/wiki/Standard_Tibetan",
				},
				{
					isO2: "br",
					family: "Indo-European",
					isO3: "bre",
					localName: "brezhoneg",
					name: "Breton",
					source: "https://en.wikipedia.org/wiki/Breton_language",
				},
				{
					isO2: "bs",
					family: "Indo-European",
					isO3: "bos",
					localName: "bosanski jezik",
					name: "Bosnian",
					source: "https://en.wikipedia.org/wiki/Bosnian_language",
				},
				{
					isO2: "ca",
					family: "Indo-European",
					isO3: "cat",
					localName: "català",
					name: "Catalan",
					source: "https://en.wikipedia.org/wiki/Catalan_language",
				},
				{
					isO2: "ce",
					family: "Northeast Caucasian",
					isO3: "che",
					localName: "нохчийн мотт",
					name: "Chechen",
					source: "https://en.wikipedia.org/wiki/Chechen_language",
				},
				{
					isO2: "ch",
					family: "Austronesian",
					isO3: "cha",
					localName: "Chamoru",
					name: "Chamorro",
					source: "https://en.wikipedia.org/wiki/Chamorro_language",
				},
				{
					isO2: "co",
					family: "Indo-European",
					isO3: "cos",
					localName: "corsu, lingua corsa",
					name: "Corsican",
					source: "https://en.wikipedia.org/wiki/Corsican_language",
				},
				{
					isO2: "cr",
					family: "Algonquian",
					isO3: "cre",
					localName: "ᓀᐦᐃᔭᐍᐏᐣ",
					name: "Cree",
					source: "https://en.wikipedia.org/wiki/Cree_language",
				},
				{
					isO2: "cs",
					family: "Indo-European",
					isO3: "ces",
					localName: "čeština, český jazyk",
					name: "Czech",
					source: "https://en.wikipedia.org/wiki/Czech_language",
				},
				{
					isO2: "cu",
					family: "Indo-European",
					isO3: "chu",
					localName: "ѩзыкъ словѣньскъ",
					name: "Old Church Slavonic, Church Slavonic, Old Bulgarian",
					source: "https://en.wikipedia.org/wiki/Old_Church_Slavonic",
				},
				{
					isO2: "cv",
					family: "Turkic",
					isO3: "chv",
					localName: "чӑваш чӗлхи",
					name: "Chuvash",
					source: "https://en.wikipedia.org/wiki/Chuvash_language",
				},
				{
					isO2: "cy",
					family: "Indo-European",
					isO3: "cym",
					localName: "Cymraeg",
					name: "Welsh",
					source: "https://en.wikipedia.org/wiki/Welsh_language",
				},
				{
					isO2: "da",
					family: "Indo-European",
					isO3: "dan",
					localName: "dansk",
					name: "Danish",
					source: "https://en.wikipedia.org/wiki/Danish_language",
				},
				{
					isO2: "de",
					family: "Indo-European",
					isO3: "deu",
					localName: "Deutsch",
					name: "German",
					source: "https://en.wikipedia.org/wiki/German_language",
				},
				{
					isO2: "dv",
					family: "Indo-European",
					isO3: "div",
					localName: "ދިވެހި",
					name: "Divehi, Dhivehi, Maldivian",
					source: "https://en.wikipedia.org/wiki/Dhivehi_language",
				},
				{
					isO2: "dz",
					family: "Sino-Tibetan",
					isO3: "dzo",
					localName: "རྫོང་ཁ",
					name: "Dzongkha",
					source: "https://en.wikipedia.org/wiki/Dzongkha_language",
				},
				{
					isO2: "ee",
					family: "Niger–Congo",
					isO3: "ewe",
					localName: "Eʋegbe",
					name: "Ewe",
					source: "https://en.wikipedia.org/wiki/Ewe_language",
				},
				{
					isO2: "el",
					family: "Indo-European",
					isO3: "ell",
					localName: "ελληνικά",
					name: "Greek (modern)",
					source: "https://en.wikipedia.org/wiki/Greek_language",
				},
				{
					isO2: "en",
					family: "Indo-European",
					isO3: "eng",
					localName: "English",
					name: "English",
					source: "https://en.wikipedia.org/wiki/English_language",
				},
				{
					isO2: "eo",
					family: "Constructed",
					isO3: "epo",
					localName: "Esperanto",
					name: "Esperanto",
					source: "https://en.wikipedia.org/wiki/Esperanto",
				},
				{
					isO2: "es",
					family: "Indo-European",
					isO3: "spa",
					localName: "Español",
					name: "Spanish",
					source: "https://en.wikipedia.org/wiki/Spanish_language",
				},
				{
					isO2: "et",
					family: "Uralic",
					isO3: "est",
					localName: "eesti, eesti keel",
					name: "Estonian",
					source: "https://en.wikipedia.org/wiki/Estonian_language",
				},
				{
					isO2: "eu",
					family: "Language isolate",
					isO3: "eus",
					localName: "euskara, euskera",
					name: "Basque",
					source: "https://en.wikipedia.org/wiki/Basque_language",
				},
				{
					isO2: "fa",
					family: "Indo-European",
					isO3: "fas",
					localName: "فارسی",
					name: "Persian (Farsi)",
					source: "https://en.wikipedia.org/wiki/Persian_language",
				},
				{
					isO2: "ff",
					family: "Niger–Congo",
					isO3: "ful",
					localName: "Fulfulde, Pulaar, Pular",
					name: "Fula, Fulah, Pulaar, Pular",
					source: "https://en.wikipedia.org/wiki/Fula_language",
				},
				{
					isO2: "fi",
					family: "Uralic",
					isO3: "fin",
					localName: "suomi, suomen kieli",
					name: "Finnish",
					source: "https://en.wikipedia.org/wiki/Finnish_language",
				},
				{
					isO2: "fj",
					family: "Austronesian",
					isO3: "fij",
					localName: "vosa Vakaviti",
					name: "Fijian",
					source: "https://en.wikipedia.org/wiki/Fijian_language",
				},
				{
					isO2: "fo",
					family: "Indo-European",
					isO3: "fao",
					localName: "føroyskt",
					name: "Faroese",
					source: "https://en.wikipedia.org/wiki/Faroese_language",
				},
				{
					isO2: "fr",
					family: "Indo-European",
					isO3: "fra",
					localName: "français, langue française",
					name: "French",
					source: "https://en.wikipedia.org/wiki/French_language",
				},
				{
					isO2: "fy",
					family: "Indo-European",
					isO3: "fry",
					localName: "Frysk",
					name: "Western Frisian",
					source: "https://en.wikipedia.org/wiki/West_Frisian_language",
				},
				{
					isO2: "ga",
					family: "Indo-European",
					isO3: "gle",
					localName: "Gaeilge",
					name: "Irish",
					source: "https://en.wikipedia.org/wiki/Irish_language",
				},
				{
					isO2: "gd",
					family: "Indo-European",
					isO3: "gla",
					localName: "Gàidhlig",
					name: "Scottish Gaelic, Gaelic",
					source: "https://en.wikipedia.org/wiki/Scottish_Gaelic_language",
				},
				{
					isO2: "gl",
					family: "Indo-European",
					isO3: "glg",
					localName: "galego",
					name: "Galician",
					source: "https://en.wikipedia.org/wiki/Galician_language",
				},
				{
					isO2: "gn",
					family: "Tupian",
					isO3: "grn",
					localName: "Avañe'ẽ",
					name: "Guaraní",
					source: "https://en.wikipedia.org/wiki/Guaran%C3%AD_language",
				},
				{
					isO2: "gu",
					family: "Indo-European",
					isO3: "guj",
					localName: "ગુજરાતી",
					name: "Gujarati",
					source: "https://en.wikipedia.org/wiki/Gujarati_language",
				},
				{
					isO2: "gv",
					family: "Indo-European",
					isO3: "glv",
					localName: "Gaelg, Gailck",
					name: "Manx",
					source: "https://en.wikipedia.org/wiki/Manx_language",
				},
				{
					isO2: "ha",
					family: "Afro-Asiatic",
					isO3: "hau",
					localName: "(Hausa) هَوُسَ",
					name: "Hausa",
					source: "https://en.wikipedia.org/wiki/Hausa_language",
				},
				{
					isO2: "he",
					family: "Afro-Asiatic",
					isO3: "heb",
					localName: "עברית",
					name: "Hebrew (modern)",
					source: "https://en.wikipedia.org/wiki/Hebrew_language",
				},
				{
					isO2: "hi",
					family: "Indo-European",
					isO3: "hin",
					localName: "हिन्दी, हिंदी",
					name: "Hindi",
					source: "https://en.wikipedia.org/wiki/Hindi",
				},
				{
					isO2: "ho",
					family: "Austronesian",
					isO3: "hmo",
					localName: "Hiri Motu",
					name: "Hiri Motu",
					source: "https://en.wikipedia.org/wiki/Hiri_Motu_language",
				},
				{
					isO2: "hr",
					family: "Indo-European",
					isO3: "hrv",
					localName: "hrvatski jezik",
					name: "Croatian",
					source: "https://en.wikipedia.org/wiki/Croatian_language",
				},
				{
					isO2: "ht",
					family: "Creole",
					isO3: "hat",
					localName: "Kreyòl ayisyen",
					name: "Haitian, Haitian Creole",
					source: "https://en.wikipedia.org/wiki/Haitian_Creole_language",
				},
				{
					isO2: "hu",
					family: "Uralic",
					isO3: "hun",
					localName: "magyar",
					name: "Hungarian",
					source: "https://en.wikipedia.org/wiki/Hungarian_language",
				},
				{
					isO2: "hy",
					family: "Indo-European",
					isO3: "hye",
					localName: "Հայերեն",
					name: "Armenian",
					source: "https://en.wikipedia.org/wiki/Armenian_language",
				},
				{
					isO2: "hz",
					family: "Niger–Congo",
					isO3: "her",
					localName: "Otjiherero",
					name: "Herero",
					source: "https://en.wikipedia.org/wiki/Herero_language",
				},
				{
					isO2: "ia",
					family: "Constructed",
					isO3: "ina",
					localName: "Interlingua",
					name: "Interlingua",
					source: "https://en.wikipedia.org/wiki/Interlingua",
				},
				{
					isO2: "id",
					family: "Austronesian",
					isO3: "ind",
					localName: "Bahasa Indonesia",
					name: "Indonesian",
					source: "https://en.wikipedia.org/wiki/Indonesian_language",
				},
				{
					isO2: "ig",
					family: "Niger–Congo",
					isO3: "ibo",
					localName: "Asụsụ Igbo",
					name: "Igbo",
					source: "https://en.wikipedia.org/wiki/Igbo_language",
				},
				{
					isO2: "ii",
					family: "Sino-Tibetan",
					isO3: "iii",
					localName: "ꆈꌠ꒿ Nuosuhxop",
					name: "Nuosu",
					source: "https://en.wikipedia.org/wiki/Nuosu_language",
				},
				{
					isO2: "ik",
					family: "Eskimo–Aleut",
					isO3: "ipk",
					localName: "Iñupiaq, Iñupiatun",
					name: "Inupiaq",
					source: "https://en.wikipedia.org/wiki/Inupiaq_language",
				},
				{
					isO2: "io",
					family: "Constructed",
					isO3: "ido",
					localName: "Ido",
					name: "Ido",
					source: "https://en.wikipedia.org/wiki/Ido_(language)",
				},
				{
					isO2: "is",
					family: "Indo-European",
					isO3: "isl",
					localName: "Íslenska",
					name: "Icelandic",
					source: "https://en.wikipedia.org/wiki/Icelandic_language",
				},
				{
					isO2: "it",
					family: "Indo-European",
					isO3: "ita",
					localName: "Italiano",
					name: "Italian",
					source: "https://en.wikipedia.org/wiki/Italian_language",
				},
				{
					isO2: "iu",
					family: "Eskimo–Aleut",
					isO3: "iku",
					localName: "ᐃᓄᒃᑎᑐᑦ",
					name: "Inuktitut",
					source: "https://en.wikipedia.org/wiki/Inuktitut",
				},
				{
					isO2: "ja",
					family: "Japonic",
					isO3: "jpn",
					localName: "日本語 (にほんご)",
					name: "Japanese",
					source: "https://en.wikipedia.org/wiki/Japanese_language",
				},
				{
					isO2: "jv",
					family: "Austronesian",
					isO3: "jav",
					localName: "ꦧꦱꦗꦮ, Basa Jawa",
					name: "Javanese",
					source: "https://en.wikipedia.org/wiki/Javanese_language",
				},
				{
					isO2: "ka",
					family: "South Caucasian",
					isO3: "kat",
					localName: "ქართული",
					name: "Georgian",
					source: "https://en.wikipedia.org/wiki/Georgian_language",
				},
				{
					isO2: "kg",
					family: "Niger–Congo",
					isO3: "kon",
					localName: "Kikongo",
					name: "Kongo",
					source: "https://en.wikipedia.org/wiki/Kongo_language",
				},
				{
					isO2: "ki",
					family: "Niger–Congo",
					isO3: "kik",
					localName: "Gĩkũyũ",
					name: "Kikuyu, Gikuyu",
					source: "https://en.wikipedia.org/wiki/Gikuyu_language",
				},
				{
					isO2: "kj",
					family: "Niger–Congo",
					isO3: "kua",
					localName: "Kuanyama",
					name: "Kwanyama, Kuanyama",
					source: "https://en.wikipedia.org/wiki/Kwanyama",
				},
				{
					isO2: "kk",
					family: "Turkic",
					isO3: "kaz",
					localName: "қазақ тілі",
					name: "Kazakh",
					source: "https://en.wikipedia.org/wiki/Kazakh_language",
				},
				{
					isO2: "kl",
					family: "Eskimo–Aleut",
					isO3: "kal",
					localName: "kalaallisut, kalaallit oqaasii",
					name: "Kalaallisut, Greenlandic",
					source: "https://en.wikipedia.org/wiki/Kalaallisut_language",
				},
				{
					isO2: "km",
					family: "Austroasiatic",
					isO3: "khm",
					localName: "ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ",
					name: "Khmer",
					source: "https://en.wikipedia.org/wiki/Khmer_language",
				},
				{
					isO2: "kn",
					family: "Dravidian",
					isO3: "kan",
					localName: "ಕನ್ನಡ",
					name: "Kannada",
					source: "https://en.wikipedia.org/wiki/Kannada_language",
				},
				{
					isO2: "ko",
					family: "Koreanic",
					isO3: "kor",
					localName: "한국어",
					name: "Korean",
					source: "https://en.wikipedia.org/wiki/Korean_language",
				},
				{
					isO2: "kr",
					family: "Nilo-Saharan",
					isO3: "kau",
					localName: "Kanuri",
					name: "Kanuri",
					source: "https://en.wikipedia.org/wiki/Kanuri_language",
				},
				{
					isO2: "ks",
					family: "Indo-European",
					isO3: "kas",
					localName: "कश्मीरी, كشميري‎",
					name: "Kashmiri",
					source: "https://en.wikipedia.org/wiki/Kashmiri_language",
				},
				{
					isO2: "ku",
					family: "Indo-European",
					isO3: "kur",
					localName: "Kurdî, كوردی‎",
					name: "Kurdish",
					source: "https://en.wikipedia.org/wiki/Kurdish_language",
				},
				{
					isO2: "kv",
					family: "Uralic",
					isO3: "kom",
					localName: "коми кыв",
					name: "Komi",
					source: "https://en.wikipedia.org/wiki/Komi_language",
				},
				{
					isO2: "kw",
					family: "Indo-European",
					isO3: "cor",
					localName: "Kernewek",
					name: "Cornish",
					source: "https://en.wikipedia.org/wiki/Cornish_language",
				},
				{
					isO2: "ky",
					family: "Turkic",
					isO3: "kir",
					localName: "Кыргызча, Кыргыз тили",
					name: "Kyrgyz",
					source: "https://en.wikipedia.org/wiki/Kyrgyz_language",
				},
				{
					isO2: "la",
					family: "Indo-European",
					isO3: "lat",
					localName: "latine, lingua latina",
					name: "Latin",
					source: "https://en.wikipedia.org/wiki/Latin",
				},
				{
					isO2: "lb",
					family: "Indo-European",
					isO3: "ltz",
					localName: "Lëtzebuergesch",
					name: "Luxembourgish, Letzeburgesch",
					source: "https://en.wikipedia.org/wiki/Luxembourgish_language",
				},
				{
					isO2: "lg",
					family: "Niger–Congo",
					isO3: "lug",
					localName: "Luganda",
					name: "Ganda",
					source: "https://en.wikipedia.org/wiki/Luganda",
				},
				{
					isO2: "li",
					family: "Indo-European",
					isO3: "lim",
					localName: "Limburgs",
					name: "Limburgish, Limburgan, Limburger",
					source: "https://en.wikipedia.org/wiki/Limburgish_language",
				},
				{
					isO2: "ln",
					family: "Niger–Congo",
					isO3: "lin",
					localName: "Lingála",
					name: "Lingala",
					source: "https://en.wikipedia.org/wiki/Lingala_language",
				},
				{
					isO2: "lo",
					family: "Tai–Kadai",
					isO3: "lao",
					localName: "ພາສາລາວ",
					name: "Lao",
					source: "https://en.wikipedia.org/wiki/Lao_language",
				},
				{
					isO2: "lt",
					family: "Indo-European",
					isO3: "lit",
					localName: "lietuvių kalba",
					name: "Lithuanian",
					source: "https://en.wikipedia.org/wiki/Lithuanian_language",
				},
				{
					isO2: "lu",
					family: "Niger–Congo",
					isO3: "lub",
					localName: "Tshiluba",
					name: "Luba-Katanga",
					source: "https://en.wikipedia.org/wiki/Tshiluba_language",
				},
				{
					isO2: "lv",
					family: "Indo-European",
					isO3: "lav",
					localName: "latviešu valoda",
					name: "Latvian",
					source: "https://en.wikipedia.org/wiki/Latvian_language",
				},
				{
					isO2: "mg",
					family: "Austronesian",
					isO3: "mlg",
					localName: "fiteny malagasy",
					name: "Malagasy",
					source: "https://en.wikipedia.org/wiki/Malagasy_language",
				},
				{
					isO2: "mh",
					family: "Austronesian",
					isO3: "mah",
					localName: "Kajin M̧ajeļ",
					name: "Marshallese",
					source: "https://en.wikipedia.org/wiki/Marshallese_language",
				},
				{
					isO2: "mi",
					family: "Austronesian",
					isO3: "mri",
					localName: "te reo Māori",
					name: "Maori",
					source: "https://en.wikipedia.org/wiki/M%C4%81ori_language",
				},
				{
					isO2: "mk",
					family: "Indo-European",
					isO3: "mkd",
					localName: "македонски јазик",
					name: "Macedonian",
					source: "https://en.wikipedia.org/wiki/Macedonian_language",
				},
				{
					isO2: "ml",
					family: "Dravidian",
					isO3: "mal",
					localName: "മലയാളം",
					name: "Malayalam",
					source: "https://en.wikipedia.org/wiki/Malayalam_language",
				},
				{
					isO2: "mn",
					family: "Mongolic",
					isO3: "mon",
					localName: "Монгол хэл",
					name: "Mongolian",
					source: "https://en.wikipedia.org/wiki/Mongolian_language",
				},
				{
					isO2: "mr",
					family: "Indo-European",
					isO3: "mar",
					localName: "मराठी",
					name: "Marathi (Mara?hi)",
					source: "https://en.wikipedia.org/wiki/Marathi_language",
				},
				{
					isO2: "ms",
					family: "Austronesian",
					isO3: "msa",
					localName: "bahasa Melayu, بهاس ملايو‎",
					name: "Malay",
					source: "https://en.wikipedia.org/wiki/Malay_language",
				},
				{
					isO2: "mt",
					family: "Afro-Asiatic",
					isO3: "mlt",
					localName: "Malti",
					name: "Maltese",
					source: "https://en.wikipedia.org/wiki/Maltese_language",
				},
				{
					isO2: "my",
					family: "Sino-Tibetan",
					isO3: "mya",
					localName: "ဗမာစာ",
					name: "Burmese",
					source: "https://en.wikipedia.org/wiki/Burmese_language",
				},
				{
					isO2: "na",
					family: "Austronesian",
					isO3: "nau",
					localName: "Dorerin Naoero",
					name: "Nauruan",
					source: "https://en.wikipedia.org/wiki/Nauruan_language",
				},
				{
					isO2: "nb",
					family: "Indo-European",
					isO3: "nob",
					localName: "Norsk bokmål",
					name: "Norwegian Bokmål",
					source: "https://en.wikipedia.org/wiki/Bokm%C3%A5l",
				},
				{
					isO2: "nd",
					family: "Niger–Congo",
					isO3: "nde",
					localName: "isiNdebele",
					name: "Northern Ndebele",
					source: "https://en.wikipedia.org/wiki/Northern_Ndebele_language",
				},
				{
					isO2: "ne",
					family: "Indo-European",
					isO3: "nep",
					localName: "नेपाली",
					name: "Nepali",
					source: "https://en.wikipedia.org/wiki/Nepali_language",
				},
				{
					isO2: "ng",
					family: "Niger–Congo",
					isO3: "ndo",
					localName: "Owambo",
					name: "Ndonga",
					source: "https://en.wikipedia.org/wiki/Ndonga",
				},
				{
					isO2: "nl",
					family: "Indo-European",
					isO3: "nld",
					localName: "Nederlands, Vlaams",
					name: "Dutch",
					source: "https://en.wikipedia.org/wiki/Dutch_language",
				},
				{
					isO2: "nn",
					family: "Indo-European",
					isO3: "nno",
					localName: "Norsk nynorsk",
					name: "Norwegian Nynorsk",
					source: "https://en.wikipedia.org/wiki/Nynorsk",
				},
				{
					isO2: "no",
					family: "Indo-European",
					isO3: "nor",
					localName: "Norsk",
					name: "Norwegian",
					source: "https://en.wikipedia.org/wiki/Norwegian_language",
				},
				{
					isO2: "nr",
					family: "Niger–Congo",
					isO3: "nbl",
					localName: "isiNdebele",
					name: "Southern Ndebele",
					source: "https://en.wikipedia.org/wiki/Southern_Ndebele_language",
				},
				{
					isO2: "nv",
					family: "Dené–Yeniseian",
					isO3: "nav",
					localName: "Diné bizaad",
					name: "Navajo, Navaho",
					source: "https://en.wikipedia.org/wiki/Navajo_language",
				},
				{
					isO2: "ny",
					family: "Niger–Congo",
					isO3: "nya",
					localName: "chiCheŵa, chinyanja",
					name: "Chichewa, Chewa, Nyanja",
					source: "https://en.wikipedia.org/wiki/Chichewa_language",
				},
				{
					isO2: "oc",
					family: "Indo-European",
					isO3: "oci",
					localName: "occitan, lenga d'òc",
					name: "Occitan",
					source: "https://en.wikipedia.org/wiki/Occitan_language",
				},
				{
					isO2: "oj",
					family: "Algonquian",
					isO3: "oji",
					localName: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
					name: "Ojibwe, Ojibwa",
					source: "https://en.wikipedia.org/wiki/Ojibwe_language",
				},
				{
					isO2: "om",
					family: "Afro-Asiatic",
					isO3: "orm",
					localName: "Afaan Oromoo",
					name: "Oromo",
					source: "https://en.wikipedia.org/wiki/Oromo_language",
				},
				{
					isO2: "or",
					family: "Indo-European",
					isO3: "ori",
					localName: "ଓଡ଼ିଆ",
					name: "Oriya",
					source: "https://en.wikipedia.org/wiki/Oriya_language",
				},
				{
					isO2: "os",
					family: "Indo-European",
					isO3: "oss",
					localName: "ирон æвзаг",
					name: "Ossetian, Ossetic",
					source: "https://en.wikipedia.org/wiki/Ossetic_language",
				},
				{
					isO2: "pa",
					family: "Indo-European",
					isO3: "pan",
					localName: "ਪੰਜਾਬੀ",
					name: "(Eastern) Punjabi",
					source: "https://en.wikipedia.org/wiki/Eastern_Punjabi_language",
				},
				{
					isO2: "pi",
					family: "Indo-European",
					isO3: "pli",
					localName: "पाऴि",
					name: "Pali",
					source: "https://en.wikipedia.org/wiki/P%C4%81li_language",
				},
				{
					isO2: "pl",
					family: "Indo-European",
					isO3: "pol",
					localName: "język polski, polszczyzna",
					name: "Polish",
					source: "https://en.wikipedia.org/wiki/Polish_language",
				},
				{
					isO2: "ps",
					family: "Indo-European",
					isO3: "pus",
					localName: "پښتو",
					name: "Pashto, Pushto",
					source: "https://en.wikipedia.org/wiki/Pashto_language",
				},
				{
					isO2: "pt",
					family: "Indo-European",
					isO3: "por",
					localName: "Português",
					name: "Portuguese",
					source: "https://en.wikipedia.org/wiki/Portuguese_language",
				},
				{
					isO2: "qu",
					family: "Quechuan",
					isO3: "que",
					localName: "Runa Simi, Kichwa",
					name: "Quechua",
					source: "https://en.wikipedia.org/wiki/Quechua_language",
				},
				{
					isO2: "rm",
					family: "Indo-European",
					isO3: "roh",
					localName: "rumantsch grischun",
					name: "Romansh",
					source: "https://en.wikipedia.org/wiki/Romansh_language",
				},
				{
					isO2: "rn",
					family: "Niger–Congo",
					isO3: "run",
					localName: "Ikirundi",
					name: "Kirundi",
					source: "https://en.wikipedia.org/wiki/Kirundi",
				},
				{
					isO2: "ro",
					family: "Indo-European",
					isO3: "ron",
					localName: "Română",
					name: "Romanian",
					source: "https://en.wikipedia.org/wiki/Romanian_language",
				},
				{
					isO2: "ru",
					family: "Indo-European",
					isO3: "rus",
					localName: "Русский",
					name: "Russian",
					source: "https://en.wikipedia.org/wiki/Russian_language",
				},
				{
					isO2: "rw",
					family: "Niger–Congo",
					isO3: "kin",
					localName: "Ikinyarwanda",
					name: "Kinyarwanda",
					source: "https://en.wikipedia.org/wiki/Kinyarwanda",
				},
				{
					isO2: "sa",
					family: "Indo-European",
					isO3: "san",
					localName: "संस्कृतम्",
					name: "Sanskrit (Sa?sk?ta)",
					source: "https://en.wikipedia.org/wiki/Sanskrit",
				},
				{
					isO2: "sc",
					family: "Indo-European",
					isO3: "srd",
					localName: "sardu",
					name: "Sardinian",
					source: "https://en.wikipedia.org/wiki/Sardinian_language",
				},
				{
					isO2: "sd",
					family: "Indo-European",
					isO3: "snd",
					localName: "सिन्धी, سنڌي، سندھی‎",
					name: "Sindhi",
					source: "https://en.wikipedia.org/wiki/Sindhi_language",
				},
				{
					isO2: "se",
					family: "Uralic",
					isO3: "sme",
					localName: "Davvisámegiella",
					name: "Northern Sami",
					source: "https://en.wikipedia.org/wiki/Northern_Sami",
				},
				{
					isO2: "sg",
					family: "Creole",
					isO3: "sag",
					localName: "yângâ tî sängö",
					name: "Sango",
					source: "https://en.wikipedia.org/wiki/Sango_language",
				},
				{
					isO2: "si",
					family: "Indo-European",
					isO3: "sin",
					localName: "සිංහල",
					name: "Sinhalese, Sinhala",
					source: "https://en.wikipedia.org/wiki/Sinhalese_language",
				},
				{
					isO2: "sk",
					family: "Indo-European",
					isO3: "slk",
					localName: "slovenčina, slovenský jazyk",
					name: "Slovak",
					source: "https://en.wikipedia.org/wiki/Slovak_language",
				},
				{
					isO2: "sl",
					family: "Indo-European",
					isO3: "slv",
					localName: "slovenski jezik, slovenščina",
					name: "Slovene",
					source: "https://en.wikipedia.org/wiki/Slovene_language",
				},
				{
					isO2: "sm",
					family: "Austronesian",
					isO3: "smo",
					localName: "gagana fa'a Samoa",
					name: "Samoan",
					source: "https://en.wikipedia.org/wiki/Samoan_language",
				},
				{
					isO2: "sn",
					family: "Niger–Congo",
					isO3: "sna",
					localName: "chiShona",
					name: "Shona",
					source: "https://en.wikipedia.org/wiki/Shona_language",
				},
				{
					isO2: "so",
					family: "Afro-Asiatic",
					isO3: "som",
					localName: "Soomaaliga, af Soomaali",
					name: "Somali",
					source: "https://en.wikipedia.org/wiki/Somali_language",
				},
				{
					isO2: "sq",
					family: "Indo-European",
					isO3: "sqi",
					localName: "Shqip",
					name: "Albanian",
					source: "https://en.wikipedia.org/wiki/Albanian_language",
				},
				{
					isO2: "sr",
					family: "Indo-European",
					isO3: "srp",
					localName: "српски језик",
					name: "Serbian",
					source: "https://en.wikipedia.org/wiki/Serbian_language",
				},
				{
					isO2: "ss",
					family: "Niger–Congo",
					isO3: "ssw",
					localName: "SiSwati",
					name: "Swati",
					source: "https://en.wikipedia.org/wiki/Swati_language",
				},
				{
					isO2: "st",
					family: "Niger–Congo",
					isO3: "sot",
					localName: "Sesotho",
					name: "Southern Sotho",
					source: "https://en.wikipedia.org/wiki/Sotho_language",
				},
				{
					isO2: "su",
					family: "Austronesian",
					isO3: "sun",
					localName: "Basa Sunda",
					name: "Sundanese",
					source: "https://en.wikipedia.org/wiki/Sundanese_language",
				},
				{
					isO2: "sv",
					family: "Indo-European",
					isO3: "swe",
					localName: "svenska",
					name: "Swedish",
					source: "https://en.wikipedia.org/wiki/Swedish_language",
				},
				{
					isO2: "sw",
					family: "Niger–Congo",
					isO3: "swa",
					localName: "Kiswahili",
					name: "Swahili",
					source: "https://en.wikipedia.org/wiki/Swahili_language",
				},
				{
					isO2: "ta",
					family: "Dravidian",
					isO3: "tam",
					localName: "தமிழ்",
					name: "Tamil",
					source: "https://en.wikipedia.org/wiki/Tamil_language",
				},
				{
					isO2: "te",
					family: "Dravidian",
					isO3: "tel",
					localName: "తెలుగు",
					name: "Telugu",
					source: "https://en.wikipedia.org/wiki/Telugu_language",
				},
				{
					isO2: "tg",
					family: "Indo-European",
					isO3: "tgk",
					localName: "тоҷикӣ, toçikī, تاجیکی‎",
					name: "Tajik",
					source: "https://en.wikipedia.org/wiki/Tajik_language",
				},
				{
					isO2: "th",
					family: "Tai–Kadai",
					isO3: "tha",
					localName: "ไทย",
					name: "Thai",
					source: "https://en.wikipedia.org/wiki/Thai_language",
				},
				{
					isO2: "ti",
					family: "Afro-Asiatic",
					isO3: "tir",
					localName: "ትግርኛ",
					name: "Tigrinya",
					source: "https://en.wikipedia.org/wiki/Tigrinya_language",
				},
				{
					isO2: "tk",
					family: "Turkic",
					isO3: "tuk",
					localName: "Türkmen, Түркмен",
					name: "Turkmen",
					source: "https://en.wikipedia.org/wiki/Turkmen_language",
				},
				{
					isO2: "tl",
					family: "Austronesian",
					isO3: "tgl",
					localName: "Wikang Tagalog",
					name: "Tagalog",
					source: "https://en.wikipedia.org/wiki/Tagalog_language",
				},
				{
					isO2: "tn",
					family: "Niger–Congo",
					isO3: "tsn",
					localName: "Setswana",
					name: "Tswana",
					source: "https://en.wikipedia.org/wiki/Tswana_language",
				},
				{
					isO2: "to",
					family: "Austronesian",
					isO3: "ton",
					localName: "faka Tonga",
					name: "Tonga (Tonga Islands)",
					source: "https://en.wikipedia.org/wiki/Tongan_language",
				},
				{
					isO2: "tr",
					family: "Turkic",
					isO3: "tur",
					localName: "Türkçe",
					name: "Turkish",
					source: "https://en.wikipedia.org/wiki/Turkish_language",
				},
				{
					isO2: "ts",
					family: "Niger–Congo",
					isO3: "tso",
					localName: "Xitsonga",
					name: "Tsonga",
					source: "https://en.wikipedia.org/wiki/Tsonga_language",
				},
				{
					isO2: "tt",
					family: "Turkic",
					isO3: "tat",
					localName: "татар теле, tatar tele",
					name: "Tatar",
					source: "https://en.wikipedia.org/wiki/Tatar_language",
				},
				{
					isO2: "tw",
					family: "Niger–Congo",
					isO3: "twi",
					localName: "Twi",
					name: "Twi",
					source: "https://en.wikipedia.org/wiki/Twi",
				},
				{
					isO2: "ty",
					family: "Austronesian",
					isO3: "tah",
					localName: "Reo Tahiti",
					name: "Tahitian",
					source: "https://en.wikipedia.org/wiki/Tahitian_language",
				},
				{
					isO2: "ug",
					family: "Turkic",
					isO3: "uig",
					localName: "ئۇيغۇرچە‎, Uyghurche",
					name: "Uyghur",
					source: "https://en.wikipedia.org/wiki/Uyghur_language",
				},
				{
					isO2: "uk",
					family: "Indo-European",
					isO3: "ukr",
					localName: "Українська",
					name: "Ukrainian",
					source: "https://en.wikipedia.org/wiki/Ukrainian_language",
				},
				{
					isO2: "ur",
					family: "Indo-European",
					isO3: "urd",
					localName: "اردو",
					name: "Urdu",
					source: "https://en.wikipedia.org/wiki/Urdu",
				},
				{
					isO2: "uz",
					family: "Turkic",
					isO3: "uzb",
					localName: "Oʻzbek, Ўзбек, أۇزبېك‎",
					name: "Uzbek",
					source: "https://en.wikipedia.org/wiki/Uzbek_language",
				},
				{
					isO2: "ve",
					family: "Niger–Congo",
					isO3: "ven",
					localName: "Tshivenḓa",
					name: "Venda",
					source: "https://en.wikipedia.org/wiki/Venda_language",
				},
				{
					isO2: "vi",
					family: "Austroasiatic",
					isO3: "vie",
					localName: "Tiếng Việt",
					name: "Vietnamese",
					source: "https://en.wikipedia.org/wiki/Vietnamese_language",
				},
				{
					isO2: "vo",
					family: "Constructed",
					isO3: "vol",
					localName: "Volapük",
					name: "Volapük",
					source: "https://en.wikipedia.org/wiki/Volap%C3%BCk",
				},
				{
					isO2: "wa",
					family: "Indo-European",
					isO3: "wln",
					localName: "walon",
					name: "Walloon",
					source: "https://en.wikipedia.org/wiki/Walloon_language",
				},
				{
					isO2: "wo",
					family: "Niger–Congo",
					isO3: "wol",
					localName: "Wollof",
					name: "Wolof",
					source: "https://en.wikipedia.org/wiki/Wolof_language",
				},
				{
					isO2: "xh",
					family: "Niger–Congo",
					isO3: "xho",
					localName: "isiXhosa",
					name: "Xhosa",
					source: "https://en.wikipedia.org/wiki/Xhosa_language",
				},
				{
					isO2: "yi",
					family: "Indo-European",
					isO3: "yid",
					localName: "ייִדיש",
					name: "Yiddish",
					source: "https://en.wikipedia.org/wiki/Yiddish_language",
				},
				{
					isO2: "yo",
					family: "Niger–Congo",
					isO3: "yor",
					localName: "Yorùbá",
					name: "Yoruba",
					source: "https://en.wikipedia.org/wiki/Yoruba_language",
				},
				{
					isO2: "za",
					family: "Tai–Kadai",
					isO3: "zha",
					localName: "Saɯ cueŋƅ, Saw cuengh",
					name: "Zhuang, Chuang",
					source: "https://en.wikipedia.org/wiki/Zhuang_languages",
				},
				{
					isO2: "zh",
					family: "Sino-Tibetan",
					isO3: "zho",
					localName: "中文 (Zhōngwén), 汉语, 漢語",
					name: "Chinese",
					source: "https://en.wikipedia.org/wiki/Chinese_language",
				},
				{
					isO2: "zu",
					family: "Niger–Congo",
					isO3: "zul",
					localName: "isiZulu",
					name: "Zulu",
					source: "https://en.wikipedia.org/wiki/Zulu_language",
				},
			].map((language) => ({
				value: language.isO2,
				label: `${language.name} - ${language.localName}`,
				search: `${language.name} - ${language.localName}`,
			})),
		};
	},
});

function Page() {
	const { languages } = Route.useLoaderData();

	return <SignUpForm languages={languages} />;
}
